const translations = {
    critical: 'Critical'
};

export default translations;
